/* External Resources Constant */

/**
 * Facebook serves its SDK per locale, in the gettext form, and the segment is
 * part of the URL. Every locale this app ships needs an entry: an unknown
 * segment 404s, the SDK never loads, and the Facebook button silently does
 * nothing — no error, just a dead button.
 *
 * Keys are the app's BCP-47 tags so the lookup is a direct index on what
 * `resolveLocale` returns, with no second spelling to keep in sync.
 */
export const FACEBOOK_SDK_LOCALES = {
    "pt-BR": "pt_BR",
    "pt-PT": "pt_PT",
    "es-ES": "es_ES",
    "en-US": "en_US",
};

export const FACEBOOK_SDK_DEFAULT_LOCALE = "pt_BR";

/**
 * @param {string} locale a tag from `resolveLocale`
 * @returns {string} the SDK URL for that locale
 */
export function facebookSdkUrl(locale) {
    const segment = FACEBOOK_SDK_LOCALES[locale] || FACEBOOK_SDK_DEFAULT_LOCALE;
    return `//connect.facebook.com/${segment}/sdk.js`;
}

export const externalConstants = {
    FACEBOOK: {
        // Kept for callers that have no locale at hand; `facebookSdkUrl` is
        // what the injector uses.
        SDK: "//connect.facebook.com/pt_BR/sdk.js",
        SCOPE: "email",
        KEYS: {
            APP_ID: "137390569695126",
        },
    },
};
